import React from 'react';

import { getPreFilledIndexes } from '../../../constants/MemoryGames/spellingChar';
import { TtsLocale } from '../../../models/Base';
import { QuickCreateGameMode } from '../../../models/DraftStore';
import {
  TextOrderingUnit,
  TextOrderingUnitType,
} from '../../../models/GameStore';
import { splitIntoGraphme } from '../../../utils/string';

import styles from './TextJoyGroup.module.css';
interface TextJoyGroupProps {
  type: QuickCreateGameMode | undefined;
  units: TextOrderingUnit[];
  locale: TtsLocale;
  highlightColor?: string;
  onUnitClick?: (index: number) => void;
}

export const TextJoyGroup: React.FC<TextJoyGroupProps> = (
  props: TextJoyGroupProps,
) => {
  const {
    type,
    units,
    locale,
    highlightColor = '#74969A',
    onUnitClick,
  } = props;
  // const calculateHintIndex = (length: number, unitsLength: number) => {
  //   if (length <= 0) return Math.max(0, length - 1);
  //   const index = unitsLength % length;

  //   return index === 0 ? 1 : index;
  // };

  const handleUnitClick = (index: number) => {
    if (onUnitClick) {
      onUnitClick(index);
    }
  };

  return (
    <div
      className={styles.container}
      style={{ opacity: onUnitClick ? 1 : 0.7 }}
    >
      {units.map((unit, index) => {
        const spellingPreFilledIndexes =
          type === QuickCreateGameMode.Spelling
            ? getPreFilledIndexes(unit.key.length)
            : [];

        if (
          unit.type === TextOrderingUnitType.Hint ||
          unit.type === TextOrderingUnitType.Candidate
        ) {
          return (
            <span
              key={index}
              className={styles.hint}
              onClick={() => handleUnitClick(index)}
            >
              {unit.key}
            </span>
          );
        } else if (unit.type === TextOrderingUnitType.Blank) {
          // const length = unit.key.length;
          // const isShort = length <= 4;

          // let hintIndex = -1; // Default no hint
          // if (!isShort) {
          //   hintIndex = calculateHintIndex(
          //     length,
          //     units.filter((item) => item.key !== ' ').length,
          //   );
          // }

          return (
            <span
              key={index}
              className={styles.blank}
              onClick={() => handleUnitClick(index)}
            >
              {Array.from(
                splitIntoGraphme(unit.key, locale),
                (graphme, charIndex) => {
                  if (graphme.isWordLike) {
                    if (type === QuickCreateGameMode.HandWriting) {
                      return (
                        <span key={charIndex} className={styles.writingChar} />
                      );
                    } else if (type === QuickCreateGameMode.Spelling) {
                      const isPreFilled =
                        spellingPreFilledIndexes.includes(charIndex);
                      return (
                        <span
                          key={charIndex}
                          className={styles.firstChar}
                          style={{ backgroundColor: highlightColor }}
                        >
                          {isPreFilled ? unit.key[charIndex] : undefined}
                        </span>
                      );
                    } else if (charIndex === 0) {
                      return (
                        <span
                          key={charIndex}
                          className={styles.firstChar}
                          style={{ backgroundColor: highlightColor }}
                        />
                      );
                      // } else if (charIndex === hintIndex) {
                      //   return (
                      //     <span key={charIndex} className={styles.hintChar}>
                      //       {unit.key[charIndex]}
                      //     </span>
                      //   );
                    } else {
                      return (
                        <span key={charIndex} className={styles.grayBlock} />
                      );
                    }
                  } else {
                    return (
                      <span key={charIndex} className={styles.hint}>
                        {graphme.text}
                      </span>
                    );
                  }
                },
              )}
            </span>
          );
        }
        return null;
      })}
    </div>
  );
};
